import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue'
import useGlobal from '@/composables/useGlobal'
import { optionsGetter } from '@utils/helpers'
import { useTransactions } from '@/stores/transactions'


export default /*#__PURE__*/_defineComponent({
  __name: 'FiltersBar',
  props: ['fields', 'objectType', 'checkers'],
  emits: ['applyFilters', 'checkValues'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const attentionsStore = useTransactions()
const attentionsCount = computed(() => attentionsStore.attentionsCount)
const emit = __emit
const { $t } = useGlobal()
const props = __props
const form = ref({})

const clearFilters = () => {
  form.value = {}
  emit("applyFilters", {})
  // delete form.value.birthday
}

const applyFilters = () => {
  const transformedObject = {}
  for (const key in form.value) {
    if(!form.value[key]) delete form.value[key]
    if (Object.prototype.hasOwnProperty.call(form.value, key)) {
      transformedObject[key] = form.value[key]?.value !== undefined ? form.value[key].value : form.value[key];
    }
  }

  emit("applyFilters", { ...transformedObject })
 }


const __returned__ = { attentionsStore, attentionsCount, emit, $t, props, form, clearFilters, applyFilters, ref, computed, get useGlobal() { return useGlobal }, get optionsGetter() { return optionsGetter }, get useTransactions() { return useTransactions } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})